import React from "react";
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import BackToTop from "../backtotop/BackToTop";

const DashboardLayout = ({ children }) => {
  return (
    <>
      <Header />
      <SideBar />
      {children}
      <Footer />
      <BackToTop />
    </>
  );
};

export default DashboardLayout;
